<template>
   <div class="p-4">
	  <!-- <el-row class="mt-4">
	     <el-col :span="16"> <el-card class="box-card px-4">
	     <div slot="header" class="clearfix">
	       <h1 class="f18">退货订单</h1>
	     </div>
	     
	   </el-card></el-col>
	     <el-col :span="8"> <el-card class="box-card ml-4 px-4">
	     <div slot="header" class="clearfix">
	       <span>待处理订单</span>
	     </div>
	     
	   </el-card></el-col>
	   </el-row>
	  
	  <el-row class="mt-4">
	     <el-col :span="16"> <el-card class="box-card px-4">
	     <div slot="header" class="clearfix">
	       <span>维修订单</span>
	     </div>
	     
	   </el-card></el-col>
	   <el-col :span="8"> <el-card class="box-card ml-4 px-4">
	     <div slot="header" class="clearfix">
	       <span>待处理订单</span>
	     </div>
	     
	   </el-card></el-col>
	   </el-row>
	   
	  <el-row class="mt-4">
	     <el-col :span="16"> <el-card class="box-card px-4">
	     <div slot="header" class="clearfix">
	       <span>最新订单</span>
	     </div>
	     
	   </el-card></el-col>
	    <el-col :span="8"> <el-card class="box-card ml-4 px-4">
	      <div slot="header" class="clearfix">
	        <span>待处理订单</span>
	      </div>
	      
	    </el-card></el-col>
	   </el-row> -->
   </div>
</template>

<script>
    export default {
		data(){
			   return {
			}
		},
        mounted() {
		
        },
    }
</script>

<style scoped>

</style>
